(function() {
  'use strict';

  angular.module('ringbaPortal')
    .directive('trPingTreeTargets', function() {
      return {
        restrict: 'E',
        scope: {
          mode: '@',
          jtarget:'@'
        },
        controller: 'PingTreeTargetsController',
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: '/scripts/components/pingtreetargets/ping-tree-targets.view.html'
      };
    });
})();
